import { motion } from "framer-motion";
import { images } from "@/config/content";
import { useLang } from "@/i18n/LanguageContext";
import { ease } from "@/components/Reveal";

export function HumanAssistance() {
  const { t } = useLang();
  return (
    <section data-testid="human-section" className="relative overflow-hidden bg-asphalt py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-2 lg:px-8">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease }}
        >
          <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-ice sm:text-4xl">
            {t.human.titleL1}
            <span className="mt-2 block text-amber">{t.human.titleL2}</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-steel">{t.human.text}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="relative"
        >
          <div className="relative overflow-hidden rounded-2xl border border-edge">
            <img
              src={images.human}
              alt="Operatore EMME SERVICE CAR in abbigliamento alta visibilità controlla i sistemi di fissaggio del veicolo"
              loading="lazy"
              className="h-[420px] w-full object-cover"
            />
            <div className="pointer-events-none absolute inset-0 spotlight" />
          </div>
          <div className="absolute -bottom-4 -left-4 -z-10 h-24 w-24 border-b-2 border-l-2 border-amber" aria-hidden="true" />
        </motion.div>
      </div>
    </section>
  );
}
